import { ApiComponent, ApiItemType } from '@ibe/api';
import AnalyticsBase from './AnalyticsBase';

class CartEvent extends AnalyticsBase {
  component: ApiComponent | null;

  itemId?: string;

  itemType?: ApiItemType;
}

export default CartEvent;
